import {
  IPoderCalorificoNomination,
  IPoderCalorificoNominationQuery,
} from '../../core/interfaces/poder-calorifico-nomination.interface';

export class GetAllPoderCalorificoNominationAction {
  static readonly type = '[PoderCalorificoNomination] Get All';
  constructor(public query?: IPoderCalorificoNominationQuery) {}
}

export class GetPoderCalorificoNominationOptionsAction {
  static readonly type = '[PoderCalorificoNomination] Get Options';
  constructor() {}
}

export class UploadPoderCalorificoNominationAction {
  static readonly type = '[PoderCalorificoNomination] Upload File';
  constructor(public payload: File) {}
}

export class ConfirmPoderCalorificoNominationAction {
  static readonly type = '[PoderCalorificoNomination] Confirm Values';
  constructor(public payload: string[]) {} // Array de fechas en formato 'YYYY-MM-DD'
}

export class DownloadPoderCalorificoNominationTemplateAction {
  static readonly type = '[PoderCalorificoNomination] Download Template';
  constructor() {}
}

export class ClearPoderCalorificoNominationDataAction {
  static readonly type = '[PoderCalorificoNomination] Clear Data';
  constructor() {}
}
